module.exports = __webpack_public_path__ + "img/ashley-woodfolk.b43e8f30.png";